// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"589":"2abaae06","842":"0b43a16c"}[chunkId] + ".chunk.css";
};